export enum OcpsPolicyFeature {
    Privacy = 'privacy',
}

export enum PrivacyPolicySettingId {
    OptionalConnectedExperiences = 'office16;L_OptionalConnectedExperiences',
    ConnectedOfficeExperiences = 'office16;L_ConnectedOfficeExperiences',
    // Beware of the typo "Anlayzing" — this is how the server stores it
    OfficeExperiencesAnalyzingContent = 'office16;L_OfficeExperiencesAnlayzingContent',
    OfficeExperiencesDownloadingContent = 'office16;L_OfficeExperiencesDownloadingContent',
}

export type FeatureSettingIdMap = {
    [OcpsPolicyFeature.Privacy]: PrivacyPolicySettingId;
};

export type OutlookCloudPolicySettingId = FeatureSettingIdMap[OcpsPolicyFeature];
